import { gql } from '@apollo/client'

export const SCHEDULED_REVIEW_CREATE_MUTATION = gql`
  mutation SCHEDULED_REVIEW_CREATE_MUTATION($input: ScheduledReviewInput!) {
    scheduledReviewCreate(input: $input) {
      ok
      data {
        id
        planId
        companyId
        repeating
        repeatEveryValue
        repeatEveryType
        periodEndsOn
        startPeriod
        endPeriod
        scheduledReviewers {
          id
          userId
          positionId
          scheduledReviewId
          reviewDate {
            end
            value
            date
            period
          }
          user {
            id
            firstName
            lastName
            avatarUrl
          }
          position {
            id
            description
          }
        }
        endsOn
        endsOnDate
      }
    }
  }
`

export const SCHEDULED_REVIEW_UPDATE_MUTATION = gql`
  mutation SCHEDULED_REVIEW_UPDATE_MUTATION($id: ID!, $input: ScheduledReviewInput!) {
    scheduledReviewUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const SCHEDULED_REVIEW_DELETE_MUTATION = gql`
  mutation SCHEDULED_REVIEW_DELETE_MUTATION($id: ID!) {
    scheduledReviewDelete(id: $id) {
      ok
    }
  }
`

export const REVIEW_CREATE_MUTATION = gql`
  mutation REVIEW_CREATE_MUTATION($input: ReviewInput!) {
    reviewCreate(input: $input) {
      ok
      data {
        id
      }
    }
  }
`

export const REVIEW_UPDATE_MUTATION = gql`
  mutation REVIEW_UPDATE_MUTATION($id: ID!, $input: ReviewInput!) {
    reviewUpdate(id: $id, input: $input) {
      ok
    }
  }
`

export const REVIEW_DELETE_MUTATION = gql`
  mutation REVIEW_DELETE_MUTATION($id: ID!) {
    reviewDelete(id: $id) {
      ok
    }
  }
`

export const SCHEDULED_REVIEW_COPY_WITH_REVIEW_MUTATION = gql`
  mutation SCHEDULED_REVIEW_COPY_WITH_REVIEW_MUTATION($reviewId: ID, $input: ScheduledReviewInput!) {
    scheduledReviewCopyWithReview(reviewId: $reviewId, input: $input) {
      ok
    }
  }
`
